import { useState } from "react";
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import TitleContainerComponent from '../../components/layout/TitleContainerComponent';
import MainPageComponent from "../../components/page/MainPageComponent";
import useUser from '../../hooks/useUser';

function UserRecoverView() {

    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Presupuesto', href: '' }
    ];

	const _user = useUser();
    
	const [user, setUser] = useState({
		email: ""
	});

	const onSubmitForm = async (event) => {
		event.preventDefault();
		await _user.createUser(user);
	};

	const handleInputChange = (e) => {
		setUser({
			...user,
			[e.target.name]: e.target.value
		})
	}

	return (
		<div>
            <MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
				<CenterCenterVerticalContainer>
					<div className="d-flex flex-column flex-grow-1"
						style={{
							maxWidth: '25rem'
						}}
					>
						<TitleContainerComponent>
							<h1>Recuperar cuenta</h1>
						</TitleContainerComponent>
						
						<Form onSubmit={onSubmitForm} className="border rounded p-3">
							<FormGroup>
								<Label for="email">E-mail</Label>
								<Input id="email" name="email" placeholder="requerido"
									type="mail" required value={user.email} onChange={handleInputChange} />
							</FormGroup>
							<div className="d-flex flex-column">
								<Button>Recuperar</Button>
								<div className="pt-2">
									<a href={"/user/login"} target="_self" rel="noreferrer" id="TooltipExample" >Iniciar sesion</a>
								</div>
							</div>
						</Form>
					</div>
				</CenterCenterVerticalContainer>
			</MainPageComponent>
		</div>
	);
}

export default UserRecoverView;